import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {QbSalesTaxCodeDto} from "../model/QbSalesTaxCodeDto";
import {QbItemSalesTaxDto} from "../model/QbItemSalesTaxDto";

class QbItemSalesTaxSelectController implements IComponentController {
    records: QbItemSalesTaxDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllQbItemSalesTax(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.qbItemSalesTaxSubscribeAndQuery().then(ret=>this.records=ret);
    };

    $onInit(): void {
    }
    $onDestroy?() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.qbItemSalesTaxSelect', [])
    .component('qbItemSalesTaxSelect', {
        template: require('./QbItemSalesTaxSelect.html'),
        controller: QbItemSalesTaxSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
